import React, { HTMLProps, memo } from 'react';
import classnames from 'classnames';
import Element from '../../element';
import { PREFIX } from '@zmedia/bm-soccer-ui/constants';
import styles from './navbar.module.scss';

interface IProps extends HTMLProps<HTMLElement> {
    className?: string;
    children: React.ReactNode;
    active?: boolean;
    dropdown?: boolean;
    dropdownUp?: boolean;
    hoverable?: boolean;
    renderAs?: string;
    arrowless?: string;
    domRef?: any;
}

function NavbarItem(props: IProps) {
    const {
        className,
        active,
        children,
        dropdown,
        dropdownUp,
        hoverable,
        renderAs = 'li',
        arrowless,
        ...rest
    } = props;
    let as = renderAs;

    return (
        <Element
            {...rest}
            renderAs={as}
            className={classnames(styles[`${PREFIX}-navbar-item`], className, {
                [styles['is-active']]: active,
                [styles['has-dropdown']]: dropdown,
                [styles['is-hoverable']]: hoverable,
                [styles['has-dropdown-up']]: dropdownUp,
                [styles['is-arrowless']]: arrowless,
            })}
        >
            {children}
        </Element>
    );
}

export default memo(NavbarItem);
